var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 185,
    viewBox: "0 0 168 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.7146 0V41.1125L130.216 66.8011L167.425 46.2429L83.7146 0Z",
    fill: "url(#paint0_linear_4255_37)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7146 0L0 46.2429L37.217 66.8011L83.7187 41.1125V0H83.7146Z",
    fill: "url(#paint1_linear_4255_37)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05176e-05 46.2429V138.749L37.217 118.191V66.8011L3.05176e-05 46.2429Z",
    fill: "#007DF2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.217 118.191L83.7187 143.879V185L3.05176e-05 138.749L37.217 118.191Z",
    fill: "url(#paint2_linear_4255_37)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130.216 118.191L167.425 138.749L83.7187 185V143.879L130.22 118.191H130.216Z",
    fill: "#007DF2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8672 84.175H125.8V69.375H59.2L70.8672 84.175Z",
    fill: "url(#paint3_linear_4255_37)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M167.425 46.2428L97.812 84.1452H167.425V46.2428Z",
    fill: "#007DF2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2 95.275V108.225H86.1423L99.9 95.275H59.2Z",
    fill: "url(#paint4_linear_4255_37)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.35 125.8V69.8375L71.225 86.95V125.8H57.35Z",
    fill: "url(#paint5_linear_4255_37)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4255_37",
    x1: 125.57,
    y1: 0,
    x2: 125.57,
    y2: 67.1647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165591"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4255_37",
    x1: 89.0662,
    y1: 16.0611,
    x2: -17.0345,
    y2: 67.1647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E5BA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4255_37",
    x1: 41.8594,
    y1: 118.191,
    x2: 41.8594,
    y2: 185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B263F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4255_37",
    x1: 66.492,
    y1: 77.0967,
    x2: 118.303,
    y2: 65.6962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01386A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4255_37",
    x1: 99.9,
    y1: 101.75,
    x2: 58.6347,
    y2: 101.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#05192C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4255_37",
    x1: 73.5375,
    y1: 69.1107,
    x2: 61.9841,
    y2: 127.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02192F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0084FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A345C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogo);
export default __webpack_public_path__ + "static/media/newLogo.9617d99a686e847781bd993d17b37d17.svg";
export { ForwardRef as ReactComponent };